import React, { FC } from 'react';
import Dropdown, { DropdownItem, DropdownMenu, DropdownToggle } from '../../components/bootstrap/Dropdown';
import Button from '../../components/bootstrap/Button';
import { convertJsonToPdf, downloadExcel, downloadFile, printPage } from '../../services/ExportService';

interface IExportDropdownProps {
    fileName: string;
    reportData: any[];
    columnVisibilityData: any[];
    printContainerId?: string;
    customPrint?: () => void;
}

const ExportDropdown: FC<IExportDropdownProps> = ({
    fileName,
    reportData,
    columnVisibilityData,
    printContainerId = "print-container",
    customPrint
}) => {
    return (
        <Dropdown className='d-print-none'>
            <DropdownToggle hasIcon={false}>
                <Button icon='Menu' color='primary'>Export</Button>
            </DropdownToggle>
            <DropdownMenu isAlignmentEnd>
                <DropdownItem>
                    <Button
                        className="w-100"
                        color='success'
                        isLight
                        icon='Download'
                        onClick={() => {
                            downloadExcel(fileName, reportData, columnVisibilityData);
                        }}>
                        Excel
                    </Button>
                </DropdownItem>
                <DropdownItem>
                    <Button
                        className="w-100"
                        color='danger'
                        isLight
                        icon='PictureAsPdf'
                        onClick={() => {
                            convertJsonToPdf(reportData, columnVisibilityData, fileName);
                        }}>
                        PDF
                    </Button>
                </DropdownItem>
                <DropdownItem>
                    <Button
                        className="w-100"
                        color='info'
                        isLight
                        icon='Description'
                        onClick={() => {
                            downloadFile(fileName, reportData, columnVisibilityData);
                        }}>
                        CSV
                    </Button>
                </DropdownItem>
                {customPrint ? (
                    <DropdownItem>
                        <Button
                            className="w-100"
                            color='primary'
                            isLight
                            icon='Print'
                            onClick={customPrint}>
                            Print
                        </Button>
                    </DropdownItem>
                ) : (
                    <DropdownItem>
                        <Button
                            className="w-100"
                            color='primary'
                            isLight
                            icon='Print'
                            onClick={() => {
                                printPage(printContainerId, fileName, reportData, columnVisibilityData);
                            }}>
                            Print
                        </Button>
                    </DropdownItem>
                )}
            </DropdownMenu>
        </Dropdown>
    );
};

export default ExportDropdown;
